import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as R from 'ramda'

import { setMenuConfig } from 'actions'

export default function useSubMenu() {
  const menuConfig = useSelector((state) => {
    return {
      isShowSubMenu: R.path(['menuConfig', 'isShowSubMenu'], state),
      isShowToggleIcon: R.path(['menuConfig', 'isShowToggleIcon'], state),
    }
  })

  const dispatch = useDispatch()
  const setIsShowSubMenu = useCallback(
    (status) => {
      dispatch(setMenuConfig({ isShowSubMenu: status }))
    },
    [dispatch]
  )

  const setShouldShowToggleIcon = useCallback(
    (status) => {
      dispatch(setMenuConfig({ isShowToggleIcon: status }))
    },
    [dispatch]
  )

  return {
    isShowSubMenu: menuConfig.isShowSubMenu,
    isShowToggleIcon: menuConfig.isShowToggleIcon,
    setIsShowSubMenu,
    setShouldShowToggleIcon,
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useSubMenu/index.js